import { VisuallyHidden } from "@radix-ui/react-visually-hidden"
import React from "react"
import { Drawer } from "vaul"

import { PayflexLogo } from "./PayflexLogo"
import PayflexStep from "./PayflexStep"
import { PayflexTerm } from "./PayflexTerm"
import { Color } from "../../../../../constants/V2/color"
import TextButton from "../../../../elements/V2/Buttons/TextButton"
import Typography from "../../../../elements/V2/Typography"

const PAYFLEX_STEPS = [
  {
    stepCount: 1,
    label: "Shop Online and fill your cart",
  },
  {
    stepCount: 2,
    label: "Choose Payflex at checkout",
  },
  {
    stepCount: 3,
    label: "Get approved and pay 25% today with your debit or credit card",
  },
  {
    stepCount: 4,
    label: "Pay the remainder over 6-weeks. No interest. No fees.",
  },
]

const PAYFLEX_TERMS = [
  {
    term: "You must be over 18 years old",
  },
  {
    term: "You must have a valid South African ID",
  },
  {
    term: "You must have a debit or credit card issued by Mastercard, Visa or Amex",
  },
]

export const PayflexModal = () => {
  return (
    <Drawer.Portal>
      <Drawer.Overlay className="fixed -top-28 bottom-0 left-0 right-0 z-50 bg-black/30" />
      <VisuallyHidden>
        <Drawer.Description>Checkout summary</Drawer.Description>
      </VisuallyHidden>
      <Drawer.Content className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="relative max-h-[90vh] w-[90vw] overflow-scroll rounded-[26px] bg-white px-20 pb-24 pt-32 sm:max-w-[900px] sm:px-60 sm:pt-60">
          <Drawer.Trigger>
            <img
              className="absolute right-16 top-16 h-[26px] w-[24px]"
              src="/icons/payflex-close-icon.svg"
              alt="Close Dialog"
            />
          </Drawer.Trigger>
          <div className="">
            <Drawer.Title>
              <div className="flex flex-col gap-24 sm:flex-row sm:gap-[93px]">
                <PayflexLogo size="large" />
                <div className="">
                  <Typography
                    weight="book"
                    color={Color.Black}
                    font="grotesk"
                    size="lead-md"
                    text="No interest, no fees,"
                  />
                  <Typography
                    weight="book"
                    color={Color.Black}
                    font="grotesk"
                    size="lead-md"
                    text="4x instalments over 6 weeks"
                  />
                </div>
              </div>
            </Drawer.Title>
            <div className="mt-24 flex flex-col gap-[9px] sm:mt-[50px]">
              <Typography
                weight="book"
                color={Color.Black}
                font="grotesk"
                size="lead-md"
                text="How it works"
              />
              <Typography
                weight="book"
                color={Color.Black}
                font="grotesk"
                size="body-lg"
                text={`Payflex lets you get what you need now, but pay for it over four interest-free instalments. You pay 25% upfront, then three payments of 25% over the following six weeks.`}
              />
            </div>
            <div className="mt-24 flex flex-col gap-[11px] sm:mt-[43px] md:flex-row md:gap-20">
              {PAYFLEX_STEPS.map((step) => (
                <PayflexStep key={step.stepCount} {...step} />
              ))}
            </div>
            <div className="mb-24 mt-24 w-full border border-charcoal/20 sm:mb-[22px] sm:mt-[54px]" />
            <div className="flex flex-col gap-[22px] md:flex-row">
              {PAYFLEX_TERMS.map((term) => (
                <PayflexTerm key={term.term} {...term} />
              ))}
            </div>
            <div className="mt-[30px] flex w-full justify-center">
              <Typography
                weight="book"
                color={Color.PayflexNavy}
                font="grotesk"
                size="body-sm"
                text="Still want more information?"
              />
              <TextButton
                style="underlined"
                text="Click here"
                color={Color.PayflexNavy}
                textSize="body-sm"
                className="ml-1"
                linkUrl="https://payflex.co.za/how-it-works/"
              />
            </div>
          </div>
        </div>
      </Drawer.Content>
    </Drawer.Portal>
  )
}
